export default "__VITE_ASSET__DfeWcSu2__"